module.exports = __webpack_public_path__ + "img/活动奖励.ee9e2841.png";